var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (['game', 'tools'].includes(_vm.type))?_c('div',{staticClass:"tips-box"},_vm._l((_vm.data),function(item,index){
var _obj;
return _c('span',{key:index},[(item.show)?_c('span',{staticClass:"tip",class:( _obj = {}, _obj[item.type] = true, _obj )},[_vm._v(" "+_vm._s(item.name)+" ")]):_vm._e()])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }